exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.floating-menu[data-v-baf1488e] {\n  left: auto;\n  right: 16px;\n  width: 20rem;\n}\n.agentList[data-v-baf1488e] {\n  max-height: 50vh;\n  overflow-y: auto;\n}\n.connectStatusButton[data-v-baf1488e] {\n  min-width: 100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-baf1488e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/people/agents/AgentInviteButton.vue
// module id = 2881
// module chunks = 0